export default __webpack_public_path__ + "static/media/Asset 8.7b92f334.svg";